module.exports = __webpack_public_path__ + "img/radio_button_active.e44fafe4.svg";